import dayjs from "dayjs";

export const formatDateTime = (value?: string) =>
  value ? `${dayjs(value).format("DD/MM/YYYY")} | ${dayjs(value).format("h:mm A")}` : "";

export const formatPersonName = (given?: string, surname?: string) =>
  `${given ? `${given} ` : ""}${surname ?? ""}`.trim();
